import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import { EContentResponse, ESeoResponse } from "../../models/seo";
import { EBlogDetailRes, EBlogResponse, IBlogGetPage } from "../../models/blog";
import { DiscountCodeRq } from "../../models/discount";

const API = ApiEndpoints.DiscountCode;

const baseURL = envConfig.API_ENDPOINT;

const approveDiscountCode = async (
  data: DiscountCodeRq,
): Promise<IBaseResponseModel<any>> => {
  return api.post(baseURL, API.ApproveDiscountCode.url, data);
};

const DiscountService = {
  approveDiscountCode,
};

export default DiscountService;
